import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useAuthContext } from '../contexts/authContext';
import { HOME, PAGENOTFOUND } from './paths';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { esES } from '@mui/material/locale';
import variables from '../shared/styles/settings.module.scss';
import PageNotFound from '../components/components/views/pageNotFound';
import Home from '../components/pages/home/home';
import { LayoutCancilleria } from '../components/layout/cancilleria/layoutCancilleria';

const AppRoutes = () => {
    const { modeTheme } = useAuthContext();

    const theme = createTheme(
        {
            palette:
                modeTheme === 'darkMode'
                    ? {
                        // palette values for dark mode
                        primary: {
                            main: variables.whiteColor,
                            contrastText: variables.darkColor,
                            dark: variables.greyColor,
                        },
                        text: {
                            primary: variables.darkColor,
                            secondary: variables.greyColor,
                        },
                    }
                    : {
                        // palette values for light mode
                        primary: {
                            main: variables.primaryColor,
                            contrastText: variables.whiteColor,
                            dark: variables.quinaryColor,
                        },
                        text: {
                            primary: variables.darkColor,
                            secondary: variables.greyColor,
                        },
                    },
            breakpoints: {
                values: {
                    xs: 0,
                    sm: 500,
                    md: 800,
                    lg: 1200,
                    xl: 1536,
                },
            },
        },
        esES
    );

    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Routes>
                    <Route
                        path={HOME}
                        element={
                            <LayoutCancilleria>
                                <Home />
                            </LayoutCancilleria>
                        }
                    />
                    {/* <Route path={PAGENOTFOUND} element={<PageNotFound />} /> */}
                </Routes>
            </Router>
        </ThemeProvider>
    );
};

export default AppRoutes;
